import importacao from './modules/importacao';
import metadados from './modules/metadados';
import roles from './modules/roles';

// A Vuex instance is created by combining the state, the actions,
// and the mutations. Because the actions and mutations are just
// functions that do not depend on the instance itself, they can
// be easily tested or even hot-reloaded (see counter-hot example).

export default {
  modules: {
    importacao,
    metadados,
    roles,
  },
  strict: true,
};



// WEBPACK FOOTER //
// ./src/vuex/store.js